import { get } from '../../lib/ajax'
import { sessionStorageSetItem } from '../../lib/utils'

export const Collections = () => ({
  showLoadMore: false,
  isLoadMoreLoading: false,
  activeCollection: '',
  currentPage: 1,
  init() {
    window.addEventListener('popstate', this.handlePopState.bind(this))
  },

  fetchProducts(isPopState = false) {
    const collectionUrl = new URL(this.activeCollection, window.location.origin)
    const cachedProducts = sessionStorage.getItem(this.activeCollection)

    if (!this.isLoadMoreLoading && cachedProducts) {
      this.handleNewHTML(cachedProducts)
      this.handleStateChange(cachedProducts, isPopState)
      return
    }

    if (this.isLoadMoreLoading) {
      collectionUrl.searchParams.set('page', this.currentPage)
    }

    collectionUrl.searchParams.set('view', 'product-cards')
    get(collectionUrl)
      .then((res) => {
        collectionUrl.searchParams.delete('view')
        collectionUrl.searchParams.delete('page')

        this.handleNewHTML(res)
        this.handleStateChange(res, isPopState)
      })
      .catch((e) => {
        console.error(`Error while ${this.isLoadMoreLoading ? 'loading more' : 'fetching'} products:`, e)
      })
      .finally(() => {
        this.isLoadMoreLoading = false
      })
  },
  handleNewHTML(res) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')
    const newGrid = doc.querySelector('.js-product-grid')
    const newHero = doc.querySelector('picture')
    const newBadges = doc.querySelector('.badges')
    if (this.isLoadMoreLoading) {
      this.$refs.productGrid.append(...newGrid.children)
    } else {
      this.$refs.heroImage.innerHTML = newHero.innerHTML
      this.$refs.productGrid.innerHTML = newGrid.innerHTML
      this.$refs.collectionTitle.innerHTML = newGrid.getAttribute('data-collection-title')
      this.$refs.collectionShortDescription.innerHTML = newGrid.getAttribute('data-collection-short-description')
      this.$refs.productGrid.setAttribute('data-product-count', newGrid.getAttribute('data-product-count'))
      this.$refs.productGrid.setAttribute('data-collection-title', newGrid.getAttribute('data-collection-title'))
      this.$refs.productGrid.setAttribute('data-products-per-page', newGrid.getAttribute('data-products-per-page'))
      this.$dispatch('collection:changed', {
        valuePropImg: {
          src: newGrid.getAttribute('data-collection-value-prop-image-src'),
          srcset: newGrid.getAttribute('data-collection-value-prop-image-srcset'),
          badges: newBadges,
        },
        seoText: newGrid.getAttribute('data-collection-description'),
      })
    }
  },
  handleNewCollection(e, collectionUrl) {
    e.preventDefault()
    this.activeCollection = collectionUrl
    this.currentPage = 1
    this.fetchProducts()
  },
  handleLoadMore() {
    this.isLoadMoreLoading = true
    this.currentPage += 1
    this.fetchProducts()
  },
  handlePopState() {
    this.activeCollection = window.location.pathname
    this.fetchProducts(true)
  },
  handleStateChange(res, isPopState = false) {
    const totalProducts = parseInt(this.$refs.productGrid.getAttribute('data-product-count'))
    const productsPerPage = parseInt(this.$refs.productGrid.getAttribute('data-products-per-page'))
    const totalPages = Math.ceil(totalProducts / productsPerPage)
    this.showLoadMore = this.currentPage < totalPages

    if (!isPopState) {
      window.history.pushState({}, '', this.activeCollection)
    }
    if (!this.isLoadMoreLoading) {
      sessionStorageSetItem(this.activeCollection, res)
    }
  },
})
